<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <!-- <dv-loading v-if="loading">Loading...</dv-loading> -->
      <div  class="host-body">
        <div class="d-flex jc-center">
          <dv-decoration-10 class="dv-dec-10" />
          <div class="d-flex jc-center">
            <dv-decoration-8 class="dv-dec-8" :color="['#568aea', '#000000']" />
            <div class="title">
              <span class="title-text">太仓市融AI特教云平台</span>
              <dv-decoration-6
                class="dv-dec-6"
                :reverse="true"
                :color="['#50e3c2', '#67a1e5']"
              />
            </div>
            <dv-decoration-8
              class="dv-dec-8"
              :reverse="true"
              :color="['#568aea', '#000000']"
            />
          </div>
          <dv-decoration-10 class="dv-dec-10-s" />
        </div>

        <!-- 第二行 -->
        <div class="d-flex jc-between px-2">
          <div class="d-flex aside-width">
            <div class="react-left ml-4 react-l-s">
              <span class="react-before"></span>
              <!--              <span class="text">数据分析1</span>-->
              <!--              <span class="react-after"></span>-->
              <span class="text">欢迎, {{ userName }}</span>
            </div>
            <div class="react-right ml-3">
              <!--              <span class="text">数据分析2</span>-->
            </div>
          </div>
          <div class="d-flex aside-width">
            <!--            <div class="react-right bg-color-blue mr-3">-->
            <!--              <span class="text fw-b">vue-big-screen</span>-->
            <!--            </div>-->
            <div class="react-right mr-3">
              <!--              <span class="text fw-b">vue-big-screen</span>-->
            </div>
            <div class="react-right mr-4 react-l-s">
              <span class="text"
                >{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span
              >
              <!--              <span class="react-after"></span>-->
              <!--              <span class="text"-->
              <!--              >{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span-->
              <!--              >-->
            </div>
          </div>
        </div>

        <div class="body-box">
          <!-- 第三行数据 -->
          <div class="content-box">
            <div>
              <div>
                <dv-border-box-13>
                  <!--                <centerLeft1 />-->
                  <left1 />
                </dv-border-box-13>
                <dv-border-box-1>
                  <!--                <centerLeft1 />-->
                  <left2 />
                </dv-border-box-1>
              </div>
            </div>
            <!-- 中间 -->
            <div>
              <china />
            </div>
            <!-- 右边 -->
            <div>
              <div>
                <dv-border-box-12>
                  <!--                <centerLeft1 />-->
                  <right1 />
                </dv-border-box-12>
                <dv-border-box-10>
                  <!--                <centerLeft1 />-->
                  <right2 />
                </dv-border-box-10>
              </div>
            </div>
          </div>

          <!-- 第四行数据 -->
          <div class="bototm-box">
            <dv-border-box-8>
              <bottom1 />
            </dv-border-box-8>
            <dv-border-box-12>
              <bottom2 />
            </dv-border-box-12>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '../utils/drawMixin';
import { formatTime } from '../utils/index.js';
import china from './area/china';
import left1 from './area/left1';
import left2 from './area/left2';
import right1 from './area/right1';
import right2 from './area/right2';
import bottom1 from './area/bottom1';
import bottom2 from './area/bottom2';

export default {
  mixins: [drawMixin],
  data() {
    return {
      userName: null,
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
    };
  },
  components: {
    china,
    left1,
    left2,
    right1,
    right2,
    bottom1,
    bottom2
  },
  mounted() {
    this.initData();
    this.timeFn();
    this.cancelLoading();
  },
  unMounted() {
    clearInterval(this.timing);
  },
  methods: {
    /**
     * 初始化数据
     */
    initData() {
      this.userName = localStorage.getItem('userName');
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss');
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd');
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/index.scss';
</style>
